export enum TabsDescription {
  VENDOR_PENDING = 0,
  STORAGE_APPROVED = 1,
  VENDOR_REJECT = 2,
}
